import Config from './account-settings.router';
import options from './account-settings.component';

const Component = {
    selector: 'dtAccountSettings',
    options
};

export {
    Config,
    Component
};



// WEBPACK FOOTER //
// ./app/components/account-settings/index.js